export const trimCarouselBreakpoints: { lg: number; md: number } = {
    lg: 1390,
    md: 1032,
};
